import styles from "./SocialLinks.module.css";

function SocialLinks() {
  return (
    <nav
      className={styles.socialLinks}
      aria-label="Redes sociais da Delicices"
    >
      <a
        href="https://wa.me/5561994433249"
        target="_blank"
        rel="noopener noreferrer"
      >
        WhatsApp
      </a>

      <span className={styles.separator}>|</span>

      <a
        href="https://instagram.com/delicices_2025"
        target="_blank"
        rel="noopener noreferrer"
      >
        Instagram
      </a>

      <span className={styles.separator}>|</span>

      <a
        href="mailto:contato@delicices.com.br"
      >
        E-mail
      </a>
    </nav>
  );
}

export default SocialLinks;